import superiorDireito from "../../assets/superiorDireito.png";
import inferiorDireito from "../../assets/inferiorDireito.png";
import centroEsquerdo from "../../assets/centroEsquerdo.png";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import style from "./RecuperarSenha.module.css";
import { useState } from "react";
import Logo from "../../assets/logoItera.png";
import RecuperacaoDeSenhaApi from "../../services/RecuperarSenhaApi";
import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import InputNovaSenha from "../../components/inputNovaSenha/InputNovaSenha";

export default function RecuperarSenha() {
    const [email, setEmail] = useState('');
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState('');
    const [tipoAlerta, setTipoAlerta] = useState('');
    const [loading, setLoading] = useState(false);

    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    async function BotaoRecuperarSenha() {
        try {
            setLoading(true);
            await RecuperacaoDeSenhaApi.emailRecuperarSenhaAsync(email);
            setMensagemAlerta(`E-mail de recuperação enviado com sucesso!`);
            setTipoAlerta('success');
            exibirAlerta(true);
        } catch (error) {
            if (error.response && error.response.data) {
                if (error.response.data.includes("Email não encontrado")) {
                    setMensagemAlerta("O Email informado não está cadastrado.");
                } else {
                    setMensagemAlerta(`Erro ao tentar recuperar senha: ${error.response.data}`);
                }
            } else {
                setMensagemAlerta("Erro ao tentar recuperar senha. Por favor, tente novamente mais tarde.");
            }
            setTipoAlerta('danger');
            exibirAlerta(true);
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className={style.conteudo}>
            <Alerta
                tipo={tipoAlerta}
                mensagem={mensagemAlerta}
                visivel={mostrarAlerta}
                aoFechar={() => setMostrarAlerta(false)}
            />
             {loading && <Loader />}
            <div className={style.conteudo_esquerda}>
                <img src={centroEsquerdo} alt="centroEsquerdo" className={style.centro_esquerdo} />
            </div>
            <div className={style.conteudo_login}>
                <img src={Logo} alt="logo" className={style.imagem_logo} />
                <Form onSubmit={(e) => { e.preventDefault(); BotaoRecuperarSenha() }}>

                    <Form.Group controlId="formEmail" className="mb-3">
                        <InputNovaSenha id={style.campos} type="email" placeholder="e-mail" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required maxLength={100}/>
                    </Form.Group>

                    <Button variant="primary" type="submit" id={style.botao_entrar}>
                        Recuperar Senha
                    </Button>
                </Form>
                <Link to="/login" className={style.voltar_login}>Voltar ao Login</Link>
            </div>
            <div className={style.conteudo_direita}>
                <img src={superiorDireito} alt="superiorDireito" className={style.superior_direito} />
                <img src={inferiorDireito} alt="inferiorDireito" className={style.inferior_direito} />
            </div>
        </div>
    );
}